module.exports = __webpack_public_path__ + "img/BannerMob-Quanta-Bank-01.300ade27.jpg";